class ProductTabsCustom extends HTMLElement {
    constructor() {
        super();

        this.tab = this.querySelectorAll('.tab-title');
        this.tabContents = this.querySelector('.tabs-contents');
        this.tabContent = this.querySelectorAll('.tab-content');
        this.link = this.querySelectorAll('.toggleLink');
        this.tabClose = this.querySelectorAll('.pdViewTab-close');
        this.isVerticalPopup = this.dataset.vertical === 'sidebar';
        this.isVerticalSidebarMobile = this.dataset.verticalMobile === 'sidebar-mobile';

        // Lưu vị trí touch để phân biệt cuộn vs tap
        this._touchStartX = 0;
        this._touchStartY = 0;

        // === EVENT TAB TITLE ===
        for (let i = 0; i < this.tab.length; i++) {
            this.tab[i].addEventListener('click', this.tabActive.bind(this));
        }

        // === TOGGLE LINK EVENT ===
        for (let i = 0; i < this.link.length; i++) {
            this.link[i].addEventListener('click', this.tabToggle.bind(this));
        }

        // === CHỈ ĐÓNG TAB KHI THỰC SỰ TAP RA NGOÀI (ĐÃ FIX LỖI CUỘN TRANG) ===
        this._outsideClickHandler = (e) => {
            // 1. Lấy thông tin touch (nếu có)
            if (e.type === 'touchstart' && e.changedTouches) {
                const touch = e.changedTouches[0];
                this._touchStartX = touch.clientX;
                this._touchStartY = touch.clientY;
                return;
            }

            // 2. Nếu là touchend → kiểm tra có phải đang cuộn không
            if (e.type === 'touchend' && e.changedTouches) {
                const touch = e.changedTouches[0];
                const deltaX = Math.abs(touch.clientX - this._touchStartX);
                const deltaY = Math.abs(touch.clientY - this._touchStartY);

                // Nếu di chuyển > 12px → coi như đang cuộn → BỎ QUA hoàn toàn
                if (deltaX > 12 || deltaY > 12) {
                    return;
                }
            }

            // 3. Xử lý nút close
            if (e.target.matches('.pdViewTab-close') || e.target.closest('.pdViewTab-close')) {
                this.productTabClose(e);
                if (this.isVerticalPopup || this.isVerticalSidebarMobile) {
                    this.handleVerticalPopupClose(e);
                }
                return;
            }

            // 4. Chỉ đóng khi có tab đang mở + tap thật sự ra ngoài
            const hasOpenTab = this.querySelector('.toggleLink.is-open') || this.querySelector('.toggle-content.is-show');
            if (hasOpenTab && !this.contains(e.target)) {
                this.querySelectorAll('.toggleLink.is-open').forEach(el => el.classList.remove('is-open'));
                this.querySelectorAll('.toggle-content.is-show').forEach(el => el.classList.remove('is-show'));
                this.tabContents?.classList.remove('is-show');
                document.body.classList.remove('tab-popup-show', 'tab-popup-sidebar-show');
                document.querySelector('.an-horizontal-shaking')?.classList.remove('open-tab-content');
            }
        };

        // === GẮN SỰ KIỆN MỚI (có touchstart để đo khoảng cách cuộn) ===
        document.addEventListener('touchstart', this._outsideClickHandler, { passive: true });
        document.addEventListener('touchend',   this._outsideClickHandler, { passive: true });
        document.addEventListener('click',      this._outsideClickHandler);

        // Overlay đóng tab
        if (this.isVerticalPopup || this.isVerticalSidebarMobile) {
            document.querySelector('.background-overlay')?.addEventListener('click', () => {
                this.querySelectorAll('.toggleLink.is-open').forEach(el => el.classList.remove('is-open'));
                this.querySelectorAll('.toggle-content.is-show').forEach(el => el.classList.remove('is-show'));
                document.body.classList.remove('tab-popup-show', 'tab-popup-sidebar-show');
            });
        }

        // Resize + slick
        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => this.handleResizeSlick(), 200);
        });

        this.handleResizeSlick();
    }

    // ================== CÁC HÀM KHÁC GIỮ NGUYÊN HOÀN TOÀN ==================

    tabActive(event) {
        event.preventDefault();
        event.stopPropagation();
        const $this = event.currentTarget;
        const id = ($this.dataset.target || $this.getAttribute('href')).replace('#', '');
        const button_tab = document.querySelector('.an-horizontal-shaking');

        if (!$this.classList.contains('is-open')) {
            this.tab.forEach(el => el.classList.remove('is-open'));
            $this.classList.add('is-open');
            this.tabContents.classList.add('is-show');
            button_tab?.classList.add('open-tab-content');

            if (window.innerWidth > 551) {
                this.tabContent.forEach(el => {
                    el.classList.toggle('is-active', el.id === id);
                });
            }
        } else if ($this.classList.contains('open-tab-content')) {
            button_tab?.classList.remove('open-tab-content');
        }
    }

    handleResizeSlick() {
        const sliders = this.querySelectorAll('[data-spotlight-slider]');
        sliders.forEach(slider => {
            if (window.innerWidth > 550 && $(slider).hasClass('slick-initialized')) {
                $(slider).slick('unslick');
            }
        });
    }

    tabToggle(event) {
        event.preventDefault();
        event.stopPropagation();

        const $this = event.currentTarget;
        const $thisContent = $this.parentNode.nextElementSibling;

        if ($this.classList.contains('is-open')) {
            $this.classList.remove('is-open');
            if ($this.classList.contains('sidebar-mobile') && window.innerWidth <= 550) {
                $thisContent.classList.remove('is-show');
                document.body.classList.remove('tab-popup-show');
            } else {
                $($thisContent).slideUp('slow');
            }
        } else {
            $this.classList.add('is-open');
            if ($this.classList.contains('sidebar-mobile') && window.innerWidth <= 550) {
                $thisContent.classList.add('is-show');
                document.body.classList.add('tab-popup-show', 'tab-popup-sidebar-show');
            } else {
                $($thisContent).slideDown('slow');
            }

            if (window.innerWidth <= 550) {
                const slider = $thisContent.querySelector('[data-spotlight-slider]');
                if (slider && !$(slider).hasClass('slick-initialized')) {
                    $(slider).slick({
                        infinite: true,
                        speed: 1000,
                        arrows: false,
                        dots: false,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        rtl: window.rtl_slick || false,
                        responsive: [
                            { breakpoint: 1024, settings: { slidesToShow: 3 } },
                            { breakpoint: 768, settings: { slidesToShow: 1, arrows: true, centerMode: true, centerPadding: '15px' } }
                        ]
                    });
                } else if (slider) {
                    $(slider).slick('setPosition');
                }
            }
        }
    }

    productTabClose(event) {
        event.preventDefault();
        event.stopPropagation();

        this.tabContents.classList.remove('is-show');
        this.tab.forEach(el => el.classList.remove('is-open'));
        this.tabContent.forEach(el => el.classList.remove('is-active'));
        document.querySelector('.an-horizontal-shaking')?.classList.remove('open-tab-content');
        document.body.classList.remove('tab-popup-show', 'tab-popup-sidebar-show');
    }

    handleVerticalPopupClose(event) {
        const container = event.target.closest('.toggle-content') || event.target.closest('.tab-content');
        container?.classList.remove('is-show');
        container?.querySelector('.toggleLink')?.classList.remove('is-open');
        document.body.classList.remove('tab-popup-show', 'tab-popup-sidebar-show');
    }

    disconnectedCallback() {
        document.removeEventListener('touchstart', this._outsideClickHandler);
        document.removeEventListener('touchend',   this._outsideClickHandler);
        document.removeEventListener('click',      this._outsideClickHandler);
    }
}

customElements.define('product-tab-custom', ProductTabsCustom);